import React from "react";
import BaseForm from "../base/BaseForm";
import ProyectoAPI from "../../api/proyectos-api";
import Alert from "../common/Alert";
import Table from "../common/Table";
import { Panel, Description, Content, Breadcrumb, Wizard } from "../layout/Panel";
import Link from "react-router-dom/Link";
import Fa from "../common/Fa";

/**
 * Componente que representa la lista de proyectos registrados.
 */
export default class ProyectoList extends React.Component {
  state = {
    loading: true,
    filters: {}
  };

  /**
   * Se encarga de recuperar la lista de las columnas de grilla.
   */
  columns = [
    { key: "id", title: "#", isKey: true },
    { key: "nombre", title: "Proyecto" },
    { key: "departamento", title: "Departamento", isKey: false },
    { key: "distrito", title: "Distrito", isKey: false },
    {
      key: "id",
      title: "Acción",
      isKey: false,
      sort: false,
      format: this.renderAccion
    }
  ];
  /**
   * Se encarga de renderizar la celda de acción de la lista
   * @param {*} cell
   * @param {*} row
   */
  renderAccion(cell, row) {
    return (
      <React.Fragment>
      <Link className="button is-text" to={`/proyectos/${row.id}/ver`}>
        <Fa icon="eye" />
        Consultar
      </Link>
      <Link className="button is-text" to={`/proyectos/${row.id}/editar`}>
        <Fa icon="edit" />
        Editar
      </Link>
      <Link className="button is-text" to={`/proyectos/${row.id}/editar`}>
        <Fa icon="trash" />
        Eliminar
      </Link>
      </React.Fragment>
    );
  }
  /**
   * Renderiza el componente.
   */
  render() {
    return (
      <React.Fragment>
        <Wizard>
          <Breadcrumb active badge="1">
            Proyectos
          </Breadcrumb>
          <Breadcrumb badge="2">Gestionar Proyectos</Breadcrumb>
          <Breadcrumb badge="3">Consultar Proyecto</Breadcrumb>
        </Wizard>

        <Panel title="Buscar Proyectos">
          <Description>
            A travéz de esta pantalla podrás gestionar los datos de los
            proyectos.
          </Description>

          <Alert onRef={ref => (this.alert = ref)} />
          <Table
            api={ProyectoAPI}
            onRef={ref => (this.table = ref)}
            columns={this.columns}
            filters={{}}
            pagination={true}
          />
          <br />
          <hr />
          <div className="control">
            <Link className="button is-outlined" to="/proyectos/crear">
              <Fa icon="plus" />
              &nbsp;Crear Proyecto
            </Link>
          </div>
        </Panel>
      </React.Fragment>
    );
  }
}
